import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import React, { useEffect, useRef, useState } from "react";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/Player.css";
import Volume from "./Volume";
import axiosInstance from "../../../utils/axiosInstance";
import Super1dayRules from "./pop-up/super1day-rules";
import ball from '../../../assets/images/tpstudio/ball.svg';

export default function SuperOver1day() {

    const [showRules, setShowRules] = useState(false);
    const [open, setOpen] = useState(false);
    const [displayLoader, setDisplayLoader] = useState(true);
    const [activeTabIndex, setActiveTabIndex] = useState(1);
    const [roundId, setRoundId] = useState("");
    const [resultData, setResultData] = useState([]);
    const [showBetSlip, setShowBetSlip] = useState(false);

    /* ================= TIMER ================= */
    const TOTAL_SECONDS = 30;
    const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
    const localTimerRef = useRef(null);

    useEffect(() => {
        setDisplayLoader(false);

    }, []);


    const R = 45;
    const CIRC = 2 * Math.PI * R;
    const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
    const timerColor =
        timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";


    const activeTab = async (tab1) => {
        setActiveTabIndex(tab1);
        if (tab1 == 2) {
            showResultDetail();
        }
    };

    /// result detail ///
    const showResultDetail = async () => {
      let resultObj = {};
      resultObj.game_type = "tp20_virtual";

      const response = await axiosInstance.post(
        "/teenpatti-results",
        resultObj
      );

      setResultData(response.data.results_list);
      //console.log("response->", resultData);
    };

    // STAKE BUTTON CLICK
    function handleStakeClick(value) {
        const stakeInput = document.getElementById("casino_amount_web");

        let cleanValue = value.replace(/,/g, "");
        let current = parseInt(stakeInput.value) || 0;

        if (cleanValue.startsWith("+")) {
            stakeInput.value = current + parseInt(cleanValue.replace("+", ""));
        } else {
            stakeInput.value = parseInt(cleanValue);
        }
    }
    // CLEAR FUNCTION
    function clearBet() {
        document.getElementById("casino_amount_web").value = "";
        document.getElementById("span_profit_casino_web").innerText = "0";
    }
    // CLOSE FUNCTION
    function closeBetSlip() {
        setShowBetSlip(false);
    }
    // SUBMIT FUNCTION
    function submitBet() {
      let stake = parseFloat(
        document.getElementById("casino_amount_web").value
      );
      let odds = parseFloat(document.getElementById("odd_casino_web").value);

      if (!stake || stake <= 0) {
        alert("Enter valid stake");
        return;
      }

      let profit = (stake * odds).toFixed(2);
      document.getElementById("span_profit_casino_web").innerText = profit;

      //console.log({ stake, odds, profit });
    }

    function openBetSlip(odd) {
        setShowBetSlip(true);

        const oddsInput = document.getElementById("odd_casino_web");
        if (oddsInput) oddsInput.value = odd;
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
      <>
        <div className="aviator-scope player-scope aviator-bg-black">
          <ClientLayoutWithOutHeader showLoader={false}>
            <div class="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                        <TpStudioLoader displayLoader={displayLoader} />
                      </div>

                      <div
                        className="row"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="col-md-8">
                          <div className="left-content">
                            <div className="cards-layout blackjack">
                              <div>
                                <div className="cards-layout blackjack">
                                  <div
                                    className="col-12 timerDiv2"
                                    style={{ paddingLeft: "0px" }}
                                  >
                                    <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                                      <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                        <p>SUPER OVER ONE-DAY</p>
                                      </div>
                                      <div
                                        className="col-6 col-md-6 inline-block Gameidcol text-center"
                                        style={{ marginTop: "4px" }}
                                      >
                                        <div
                                          role="group"
                                          aria-label="Second group"
                                          class="btn-group btn-group-sm mr-2"
                                          style={{ float: "right" }}
                                        >
                                          <button
                                            style={{
                                              fontSize: "14px",
                                              display: "inline-block"
                                            }}
                                            type="button"
                                            className={
                                              activeTabIndex == 1
                                                ? "tablink btn btn-primary bbactive"
                                                : "tablink btn btn-primary"
                                            }
                                            onClick={() => activeTab(1)}
                                          >
                                            Game
                                          </button>
                                          <button
                                            style={{
                                              fontSize: "14px",
                                              display: "inline-block"
                                            }}
                                            type="button"
                                            className={
                                              activeTabIndex == 2
                                                ? "tablink btn btn-primary bbactive"
                                                : "tablink btn btn-primary"
                                            }
                                            onClick={() => activeTab(2)}
                                          >
                                            Results
                                          </button>
                                          <button
                                            style={{
                                              fontSize: "14px",
                                              display: "inline-block"
                                            }}
                                            type="button"
                                            class="tablink btn btn-primary2 "
                                            data-toggle="modal"
                                            data-target="#rulesPopup"
                                            onClick={() => setShowRules(true)}
                                          >
                                            Rules
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <Super1dayRules
                                    show={showRules}
                                    onClose={() => setShowRules(false)}
                                  />

                                  <span
                                    style={{
                                      opacity: 1,
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <span
                                      id="AlltabData"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    >
                                      <div
                                        id="videos"
                                        class="collapse show"
                                        aria-labelledby="headingThree"
                                        data-parent="#video"
                                        style={{
                                          textAlign: "center",
                                          padding: "0px",
                                          border: "solid 1px #130a21",
                                          minHeight: "185px",
                                          position: "relative"
                                        }}
                                      >
                                        <div className="row top-bar">
                                          <div
                                            class="col-xl-2 col-4"
                                            style={{ padding: "0px 1px" }}
                                          >
                                            <div style={{ margin: "auto" }}>
                                              <div
                                                style={{ display: "list-item" }}
                                              >
                                                <div class="player-item">
                                                  <span class="name"></span>
                                                  <div class="player-card">
                                                    <div
                                                      class="SOODSC"
                                                      style={{
                                                        borderBottom:
                                                          "1px solid",
                                                        paddingTop: "5px",
                                                        fontSize: "16px"
                                                      }}
                                                    >
                                                      <b>Afghaistan : 3</b>
                                                    </div>
                                                    <div
                                                      class="SOODSC"
                                                      style={{
                                                        paddingTop: "5px",
                                                        fontSize: "16px"
                                                      }}
                                                    >
                                                      <b>South Africa : 0</b>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            class="col-xl-3 col-6"
                                            style={{ padding: "0px" }}
                                          >
                                            <div style={{ margin: "auto" }}>
                                              <div
                                                style={{ display: "list-item" }}
                                              >
                                                <div class="player-item">
                                                  <span class="name"></span>
                                                  <div class="player-card">
                                                    <div
                                                      class="balldiv"
                                                      style={{
                                                        borderBottom:
                                                          "1px solid"
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          2
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          1
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          6
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          6
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          0
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display:
                                                            "inline-grid",
                                                          justifyItems: "center"
                                                        }}
                                                      >
                                                        <img src={ball} />
                                                        <span
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            margin: "5px auto"
                                                          }}
                                                        >
                                                          4
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div class="balldiv"></div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="casino-timer">
                                            <svg
                                              class="progressBar"
                                              x="0px"
                                              y="0px"
                                              viewBox="0 0 80 80"
                                            >
                                              <path
                                                class="track"
                                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                              ></path>
                                              <path
                                                class="fill fill_green"
                                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                                style={{
                                                  strokeDashoffset:
                                                    "-139.3274963378906"
                                                }}
                                              ></path>
                                              <text
                                                class="value"
                                                x="50%"
                                                y="55%"
                                              >
                                                {timeLeft}
                                              </text>
                                            </svg>
                                          </div>
                                        </div>

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="row">
                                              <div
                                                class="player"
                                                style={{ marginTop: "30px" }}
                                              >
                                                <div class="player-item">
                                                  <span class="name">
                                                    AFGHANISTAN
                                                  </span>
                                                  <div class="player-card">
                                                    <div
                                                      id="BFBCardHandView"
                                                      class="BFBCardHandViewDealerab"
                                                    >
                                                      <div
                                                        id="BFBCardFanView"
                                                        class="BFBCardFanViewab wrap_flex"
                                                        style={{
                                                          justifyContent:
                                                            "center"
                                                        }}
                                                      >
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_35"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_0"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_16"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_44"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_1"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_39"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row space">
                                              <div class="player">
                                                <div class="player-item">
                                                  <span class="name">
                                                    SOUTH AFRICA
                                                  </span>
                                                  <div class="player-card">
                                                    <div
                                                      id="BFBCardHandView"
                                                      class="BFBCardHandViewDealerab"
                                                    >
                                                      <div
                                                        id="BFBCardFanView"
                                                        class="BFBCardFanViewab wrap_flex"
                                                        style={{
                                                          justifyContent:
                                                            "center"
                                                        }}
                                                      >
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_15"></div>
                                                        <div class=" svg-card_simple_1-dims svg-card_simple_9"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          textAlign: "right",
                                          marginRight: "20px",
                                          marginTop: "-20px",
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                        className="volume-wrapper"
                                      >
                                        <Volume />
                                      </div>

                                      <div class="row resultDiv">
                                        <div
                                          class="results-div"
                                          id="lastresults"
                                        >
                                          <button class=" border-gradient-btn border-gradient-purple-btn">
                                            B
                                          </button>
                                          <button class="border-gradient-btn border-gradient-purple-btn">
                                            A
                                          </button>
                                          <button class="border-gradient-btn border-gradient-purple-btn">
                                            B
                                          </button>
                                        </div>
                                        <div class="round-div">
                                          <div class="label">Round ID:</div>{" "}
                                          <div id="round-id">{roundId}</div>
                                        </div>
                                      </div>

                                      <div
                                        class="tb-content"
                                        style={{ background: "#fff" }}
                                      >
                                        <div class="market-titlebar">
                                          <p class="market-name">
                                            <span class="market-name-badge">
                                              <i class="market-name-icon">
                                                <img
                                                  src="/assets/images/time-img.png"
                                                  style={{
                                                    filter: "invert(100%)",
                                                    marginTop: "-8px",
                                                    marginLeft: "-1px"
                                                  }}
                                                />
                                              </i>
                                              <span>MATCH ODDS </span>
                                            </span>
                                          </p>
                                          <div class="market-overarround">
                                            <span></span>
                                            <strong>Back</strong>
                                          </div>
                                          <div class="market-overarround market-overarround-lay">
                                            <strong>Lay</strong>
                                          </div>
                                        </div>
                                        <div class="market-runners">
                                          <div class="runner-runner">
                                            <h3
                                              class="runner-name"
                                              id="b1Sucess"
                                            >
                                              <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom:
                                                                "0px",
                                                              fontSize: "16px",
                                                              fontWeight: "700"
                                                            }}
                                                            class="clippable-spacer"
                                                          >
                                                            Afghanistan
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                onClick={() =>
                                                  openBetSlip("3.25")
                                                }
                                              >
                                                <span class="price-odd">
                                                  1.85
                                                </span>
                                                <span class="price-amount">
                                                  500,000
                                                </span>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  openBetSlip("3.25")
                                                }
                                              >
                                                <span class="price-odd">2</span>
                                                <span class="price-amount">
                                                  500,000
                                                </span>
                                              </a>
                                              <a className="price-price price-lay whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                            </div>
                                          </div>

                                          <div class="runner-runner">
                                            <h3
                                              class="runner-name"
                                              id="b2Sucess"
                                            >
                                              <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginCottom:
                                                                "0px",
                                                              fontSize: "16px",
                                                              fontWeight: "700"
                                                            }}
                                                            class="clippable-spacer"
                                                          >
                                                            South Africa
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                onClick={() =>
                                                  openBetSlip("3.25")
                                                }
                                              >
                                                <span class="price-odd">
                                                  1.85
                                                </span>
                                                <span class="price-amount">
                                                  500,000
                                                </span>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  openBetSlip("3.25")
                                                }
                                              >
                                                <span class="price-odd">2</span>
                                                <span class="price-amount">
                                                  500,000
                                                </span>
                                              </a>
                                              <a className="price-price price-lay whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                            </div>

                                            <div class="price-row-box-new"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          {showBetSlip && !isMobile && (
                            <div className="betslip-overlay">
                              <div className="betslip-modal">
                                {/* Close icon (optional) */}
                                <span
                                  className="close-icon"
                                  onClick={closeBetSlip}
                                >
                                  ×
                                </span>
                                <div id="casinoBetslipWeb" class="bets">
                                  <strong>Bet Slip </strong>
                                  <div class="betting-table">
                                    <table class="table">
                                      <thead>
                                        <tr>
                                          <th>Bet for</th>
                                          <th>Odds</th>
                                          <th>Stake</th>
                                          <th>Profit</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          class=" bgColorBetslip"
                                          style={{
                                            background: "rgb(230, 242, 252)"
                                          }}
                                        >
                                          <td>
                                            <span id="divteamname_casino_web">
                                              Total -{" "}
                                            </span>
                                          </td>
                                          <td width="10%">
                                            <div class="quantity">
                                              <input
                                                id="odd_casino_web"
                                                type="text"
                                                name="odd_casino_web"
                                                value="1.98"
                                              />
                                              <div class="quantity-nav">
                                                <div class="quantity-button quantity-up">
                                                  <span class="fa fa-caret-up"></span>
                                                </div>
                                                <div class="quantity-button quantity-down">
                                                  <span class="fa fa-caret-down"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td width="10%">
                                            <div class="stake">
                                              <input
                                                id="casino_amount_web"
                                                type="text"
                                                value=""
                                              />
                                            </div>
                                          </td>
                                          <td width="30%">
                                            <span style={{ display: "none" }}>
                                              <span id="web_profit_div_web">
                                                <span id="span_profit_casino_web">
                                                  0
                                                </span>
                                              </span>
                                              <span id="span_profit_loss_gap">
                                                / -
                                              </span>
                                              <span id="mobile_lib_div_web">
                                                <span id="span_liability_casino_web">
                                                  0
                                                </span>
                                              </span>
                                            </span>
                                          </td>
                                        </tr>
                                        <tr
                                          class=" bgColorBetslip"
                                          style={{
                                            background: "rgb(230, 242, 252)"
                                          }}
                                        >
                                          <td colspan="5">
                                            <table
                                              class="table"
                                              style={{
                                                backgroundColor: "transparent"
                                              }}
                                            >
                                              <tbody>
                                                <tr class="checknow">
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick("2000")
                                                      }
                                                    >
                                                      2,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick("5000")
                                                      }
                                                    >
                                                      5,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "10000"
                                                        )
                                                      }
                                                    >
                                                      10,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "50000"
                                                        )
                                                      }
                                                    >
                                                      50,000
                                                    </span>
                                                  </td>
                                                </tr>
                                                <tr class="checknow">
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "+1000"
                                                        )
                                                      }
                                                    >
                                                      +1,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "+5000"
                                                        )
                                                      }
                                                    >
                                                      +5,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "+10000"
                                                        )
                                                      }
                                                    >
                                                      +10,000
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="points stake_btn_web"
                                                      onClick={() =>
                                                        handleStakeClick(
                                                          "+50000"
                                                        )
                                                      }
                                                    >
                                                      +25,000
                                                    </span>
                                                  </td>
                                                </tr>
                                                <tr id="errorWebSlip">
                                                  <td
                                                    colspan="6"
                                                    class="alert-danger pr-5"
                                                  >
                                                    <span
                                                      style={{ color: "red" }}
                                                    ></span>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>
                                                    <button
                                                      class="align-left btn btn-danger"
                                                      onClick={closeBetSlip}
                                                    >
                                                      <b>Close</b>
                                                    </button>
                                                  </td>
                                                  <td>
                                                    <button
                                                      class="align-left btn btn-warning"
                                                      onClick={clearBet}
                                                    >
                                                      <b>Clear</b>
                                                    </button>
                                                  </td>
                                                  <td colspan="1"></td>
                                                  <td>
                                                    <div
                                                      class="btn btn-primary ld-over"
                                                      id="btn_place_bet_casino_web"
                                                      name="btn_place_bet_casino_web"
                                                      style={{
                                                        cursor: "pointer"
                                                      }}
                                                      onClick={submitBet}
                                                    >
                                                      <b>Submit</b>
                                                      <div class="ld ld-ball ld-flip"></div>
                                                    </div>
                                                    <div
                                                      class="btn btn-primary ld-over running"
                                                      id="btn_place_bet_casino_web"
                                                      name="btn_place_bet_casino_web"
                                                      style={{
                                                        cursor: "pointer",
                                                        display: "none"
                                                      }}
                                                    >
                                                      <b>Submit</b>
                                                      <div class="ld ld-ball ld-flip"></div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {showBetSlip && isMobile && (
                            <div className="mobile-overlay">
                              <div className="mobile-modal">
                                <div class="modal-body">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td>&nbsp;</td>
                                        <th colspan="3">Total 1</th>
                                      </tr>
                                      <tr>
                                        <td>ODDS</td>
                                        <td colspan="2">
                                          <div class="input-group mt-2">
                                            <div class="input-group-prepend">
                                              <button
                                                type="button"
                                                class="btn btn-outline-secondary"
                                              >
                                                <strong>-</strong>
                                              </button>
                                            </div>
                                            <input
                                              type="number"
                                              id="bet-price"
                                              step="0.01"
                                              min="1.01"
                                              max="1000"
                                              class="form-control"
                                            />
                                            <div class="input-group-append">
                                              <button
                                                type="button"
                                                class="btn btn-outline-secondary"
                                              >
                                                <strong>+</strong>
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Amount</td>
                                        <td colspan="2">
                                          <input
                                            type="number"
                                            id="bet-size-m"
                                            class="form-control mt-2"
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ width: "25%" }}>
                                          <button
                                            type="button"
                                            data-amount="2000"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            2,000
                                          </button>
                                        </td>
                                        <td style={{ width: "25%" }}>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            5,000
                                          </button>
                                        </td>
                                        <td style={{ width: "25%" }}>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            10,000
                                          </button>
                                        </td>
                                        <td style={{ width: "25%" }}>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            50,000
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            +1,000
                                          </button>
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            +5,000
                                          </button>
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            +10,000
                                          </button>
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-block mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                          >
                                            +25,000
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <button
                                            type="button"
                                            data-dismiss="modal"
                                            class="btn btn-danger mt-2"
                                            style={{
                                              touchAction: "manipulation"
                                            }}
                                            onClick={closeBetSlip}
                                          >
                                            Close
                                          </button>
                                        </td>
                                        <td colspan="2">
                                          <div
                                            class="btn btn-primary ld-over mt-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={submitBet}
                                          >
                                            <b>Submit</b>
                                            <div class="ld ld-ball ld-flip"></div>
                                          </div>
                                          <span>0 / -0</span>
                                        </td>
                                      </tr>
                                      <tr style={{ display: "none" }}>
                                        <td
                                          colspan="4"
                                          class="alert-danger pr-5"
                                        ></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                          <div>
                            <div className="bets">
                              <strong>
                                Matched Bets (0)
                                <img
                                  src={reconnecting}
                                  alt="dc"
                                  className="rounded disconnected"
                                  style={{ display: "none" }}
                                />{" "}
                              </strong>
                              <div className="betting-table">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Runner</th>
                                      <th>Price</th>
                                      <th>Size</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody></tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <style>
                {`
                .player {
                  margin: 4px;
                  display: inline-block;
                  justify-content: space-between;
                  flex: 1 0 0;
                  flex-wrap: wrap;
                  margin-top: -5px;
              }

              .player-item {
                margin-bottom: 16px;
                display: block;
                margin-right: 0;
                z-index: 0;
                
            }
                .player-item .name {
                    display: block;
                    color: #d7bc7b;
                    font-size: 12px;
                    font-weight: 700;
                    padding-bottom: 5px;
                    text-align: center;
                }
                .player-item .player-card {
                    border-radius: 12px;
                    border: 1px solid rgba(178, 220, 175, .25);
                }
                .BFBCardHandView {
                  transform: translate3d(0, 0, 0);
                  /* width: 220px; */
                  width: 100%;
                  height: 50px;
                  margin-top: 5px;
                  margin-bottom: 5px;
              }
                 
                .casino-timer {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    display: flex;
                    display: -webkit-flex;
                    border-radius: 50px;
                    background-color: transparent;
                }
                .progressBar{
                    width: 50px;
                    height: 50px;
                    z-index: 1;
                    background-color: transparent;
                }
                .BFBCardFanView{
                    padding:0px;
                }
                .player-scope .player-card {
                  border: 1px solid rgba(173, 172, 172, 0.5);
                  justify-content: center;
                  width: 97%;
                  height: 50px;
                  border-radius: 15px;
                  padding: 2px;
                  background: radial-gradient(ellipse at center, rgba(16, 128, 64, 0.28) 0%, rgba(0, 0, 0, 0) 60%), linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0));
              }
              .card1 {
                transform: perspective(430px) translateZ(0) rotateZ(0deg) rotateY(0deg);
                width: 40px;
                height: 50px;
                transform-origin: 50% 100%;
                margin-left: 5px;
                float: left;
            }

            .row{
              padding-left: 3px;
            }
            .video-button{
              height: 30px !important;
              width: 40px !important;
            }

            @media (max-width:576px){
              .cards-layout.blackjack {
                min-height: 120px !important;
              }
              .player-scope .table-player .player {
                width: 170px !important;
                height: 70px !important;
              }
              .titlebarname p{
                font-size: 14px;
              }
              .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .tp-card img{
                height: 55px;   
                width: auto;
                border-radius: 3px;
              }
              .row{
                padding-left: 0px;
                margin-left: -9px;
              }
              .player-item {
                margin-top: 20px !important;
              }
              .space{
                margin-top: -20px;
              }
              .player-card{
                width: 92% !important;
                height: 60px !important;
              }
              .col-md-4
              {
                margin-top: 10px;
              }
                .top-bar + .row {
                    margin-top: -25px !important;
                }
                            
                .top-bar {
                    display: flex !important;  
                    gap: 8px;               
                }
                .casino-timer {
                    flex: 0 0 auto;
                    margin-left: auto;  
                }
                    .top-bar .col-4,
                .top-bar .col-6 {
                    margin-top: -35px !important;
                }
                .balldiv {
                    display: flex !important;
                    flex-wrap: nowrap;
                    gap: 2px;
                }
                .balldiv img {
                    width: 20px;
                    height: 20px;
                }

            }
                 .mobile-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.5);
                        z-index: 9999;
                    }
                    .mobile-modal {
                        position: fixed;
                        top: 10px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 95%;
                        max-width: 420px;
                        background: #dfe7ee; 
                        border-radius: 6px;
                        padding: 15px;
                        box-shadow: 0 4px 15px rgba(0,0,0,0.3);
                        animation: slideDown 0.25s ease;
                    }
                    @keyframes slideDown {
                        from {
                            transform: translate(-50%, -30%);
                            opacity: 0;
                        }
                        to {
                            transform: translate(-50%, 0);
                            opacity: 1;
                        }
                    }
              
                `}
              </style>
            </div>
          </ClientLayoutWithOutHeader>
        </div>
      </>
    );
}
